import React, { useRef, useEffect } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import { DateTime } from 'luxon';
import { AIRQUALITY_CHART_COLORS, AIRQUALITY_TMA_CHART_COLOR, X_AXIS_LABEL_FORMAT } from './config';
export const AirQualityCombinedGraph = ({ translationData, data, secondaryData, metric, xAxisLabels, isExport, fileName, imageWidth, imageHeight }) => {
    useEffect(() => {
        if (isExport) {
            exportChart();
        }
    }, [isExport]);
    const xLabels = xAxisLabels && xAxisLabels.map(each => DateTime.fromISO(each).toFormat(X_AXIS_LABEL_FORMAT));
    const seriesData = [];
    data.forEach(item => {
        seriesData.push({
            name: item.name,
            data: item.rows,
            type: 'column',
            metric,
            marker: false,
            clip: false,
            tooltip: {
                valueSuffix: ` ${metric}`,
                pointFormat: '{series.name}: <b>{point.y}</b><br/>'
            }
        });
    });
    seriesData.push({
        data: secondaryData,
        yAxis: 1,
        marker: false,
        clip: false,
        color: AIRQUALITY_TMA_CHART_COLOR,
        name: translationData.secondaryYAxisTitle,
        tooltip: {
            pointFormat: '{series.name}: <b>{point.y}</b><br/>'
        }
    });
    const chartRef = useRef(null);
    const chartOptions = {
        title: {
            text: '',
        },
        series: seriesData,
        exporting: {
            enabled: false,
            filename: fileName,
            sourceWidth: imageWidth,
            sourceHeight: imageHeight,
        },
        xAxis: {
            categories: xLabels,
        },
        colors: AIRQUALITY_CHART_COLORS,
        yAxis: [
            {
                lineWidth: 1,
                title: {
                    text: translationData.yAxisTitle,
                },
                allowDecimals: false,
            },
            {
                lineWidth: 1,
                opposite: true,
                title: {
                    text: translationData.secondaryYAxisTitle,
                },
                allowDecimals: false,
                min: 0,
            },
        ],
        legend: {
            align: 'center',
            verticalAlign: 'top',
            layout: 'horizontal',
            squareSymbol: true,
        },
        credits: {
            enabled: false,
        },
    };
    const exportChart = () => {
        // @ts-ignore
        chartRef.current.chart.exportChart();
    };
    return (React.createElement(HighchartsReact, { containerProps: { style: { height: "100%" } }, highcharts: Exporting(Highcharts), constructorType: 'chart', options: chartOptions, ref: chartRef }));
};
//# sourceMappingURL=AirQualityCombinedGraph.js.map